/* Presentation only: no cart, checkout or catalogue mutations. */
(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 989px)');
  const initialise = () => {
    document.querySelectorAll('.gpp-category-panel').forEach(panel => {
      if (panel.dataset.gppUsabilityReady) return;
      panel.dataset.gppUsabilityReady = 'true';
      panel.open = !mobile.matches && !panel.closest('.gpp-site-top');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once:true});
  else initialise();
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href="#GppEarlyDelivery"]');
    const details = document.getElementById('GppEarlyDelivery');
    if (link && details) { details.open = true; }
  });
  // Desktop category navigation stays expanded while mobile keeps its disclosure.
  document.addEventListener('click', event => {
    const summary = event.target.closest('.gpp-shopping-shell>.gpp-category-sidebar>.gpp-category-panel>summary');
    if (summary && !mobile.matches) { event.preventDefault(); summary.parentElement.open = true; }
  });
  document.addEventListener('shopify:section:load', initialise);
  mobile.addEventListener('change', () => {
    document.querySelectorAll('.gpp-category-panel').forEach(panel => {
      panel.open = !mobile.matches && !panel.closest('.gpp-site-top');
    });
  });
})();

/* Shared delivery information on desktop and mobile; no cart/checkout writes. */
(() => {
  'use strict';
  let returnFocus = null;
  const dialog = () => document.getElementById('GppDeliveryDialog');
  const open = trigger => {
    const modal = dialog();
    if (!modal || typeof modal.showModal !== 'function') return false;
    if (!modal.open) { returnFocus = trigger; modal.showModal(); }
    return true;
  };
  const initialise = () => {
    const modal = dialog();
    if (!modal || typeof modal.showModal !== 'function') return;
    document.body.classList.add('gpp-delivery-modal-ready');
    document.querySelectorAll('[data-gpp-delivery-trigger]').forEach(trigger => {
      if (!trigger.dataset.gppDeliveryOriginalHref) trigger.dataset.gppDeliveryOriginalHref = trigger.getAttribute('href') || '';
      trigger.setAttribute('href','#GppDeliveryDialog');
      trigger.setAttribute('role','button');
      trigger.setAttribute('aria-haspopup','dialog');
      trigger.setAttribute('aria-controls','GppDeliveryDialog');
    });
    if (modal.dataset.gppDeliveryReady) return;
    modal.dataset.gppDeliveryReady = 'true';
    modal.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...modal.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])')].filter(node => node.getClientRects().length && node.tabIndex >= 0);
      const first = controls[0], last = controls[controls.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    });
    modal.addEventListener('close', () => { if (returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll:true}); returnFocus = null; });
    modal.addEventListener('click', event => {
      if (event.target.closest('[data-gpp-delivery-close]')) { modal.close(); return; }
      if (event.target === modal) { const r = modal.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) modal.close(); }
    });
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-gpp-delivery-trigger],a[href="#GppEarlyDelivery"]');
    if (trigger && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0 && open(trigger)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('keydown', event => {
    const trigger = event.target.closest('[data-gpp-delivery-trigger]');
    if (trigger && event.key === ' ') { event.preventDefault(); open(trigger); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialise,{once:true}); else initialise();
  document.addEventListener('shopify:section:load',initialise);
})();

/* Read-only typography: bounded font fit, natural wrapping and equal row title space. */
(() => {
  'use strict';
  if (window.__gppCardTitleFit) return;
  window.__gppCardTitleFit = true;
  const context = document.createElement('canvas').getContext('2d');
  if (!context) return;
  let frame = 0, observedGrid = null, lastWidth = -1;
  const schedule = () => { if (!frame) frame = requestAnimationFrame(fit); };
  const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(entries => {
    const width = entries[0]?.contentRect.width;
    if (Number.isFinite(width) && Math.abs(width - lastWidth) > 0.5) { lastWidth = width; schedule(); }
  }) : null;
  function fit() {
    frame = 0;
    const grid = document.getElementById('product-grid');
    if (grid !== observedGrid) {
      resize?.disconnect(); observedGrid = grid; lastWidth = -1;
      if (grid) resize?.observe(grid);
    }
    if (!grid) return;
    const rows = [];
    // Read-only pass: capture row membership and calculate sizes without reflowing each card.
    const records = [...grid.querySelectorAll('.card > .card__content > .card__information > .card__heading')].flatMap(heading => {
      const rect = heading.getBoundingClientRect(), link = heading.querySelector('a'), item = heading.closest('li.grid__item');
      if (!rect.width || !link || !item) return [];
      const style = getComputedStyle(link);
      let text = link.textContent.replace(/\s+/g, ' ').trim();
      if (style.textTransform === 'uppercase') text = text.toUpperCase();
      else if (style.textTransform === 'lowercase') text = text.toLowerCase();
      context.font = `${style.fontStyle} ${style.fontWeight} 16px ${style.fontFamily}`;
      if ('fontKerning' in context) context.fontKerning = style.fontKerning;
      const spacing = parseFloat(style.letterSpacing) || 0;
      const wordSpacing = parseFloat(style.wordSpacing) || 0;
      const natural = context.measureText(text).width + spacing * Math.max(0, [...text].length - 1) + wordSpacing * (text.match(/ /g) || []).length;
      const size = natural > rect.width - 1 ? Math.max(14, Math.floor(16 * (rect.width - 2) / natural * 4) / 4) : 16;
      const top = item.getBoundingClientRect().top + scrollY;
      let row = rows.find(r => Math.abs(r.top - top) < 2);
      if (!row) { row = {top, records:[]}; rows.push(row); }
      const record = {heading, size, height:0}; row.records.push(record);
      return [record];
    });
    // Batch writes, then one layout-read pass. Never alternate writes/forced layouts per title.
    for (const record of records) {
      record.heading.style.fontSize = record.size + 'px';
      record.heading.style.lineHeight = '1.35';
      record.heading.style.minHeight = '0px';
    }
    for (const record of records) record.height = record.heading.getBoundingClientRect().height;
    for (const row of rows) {
      const height = Math.ceil(Math.max(...row.records.map(r => r.height)));
      for (const record of row.records) record.heading.style.minHeight = height + 'px';
    }
  }
  function start() {
    schedule();
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(records => {
      if (records.some(r => r.target.closest?.('#product-grid') || [...r.addedNodes, ...r.removedNodes].some(n => n.nodeType === 1 && (n.id === 'product-grid' || n.querySelector?.('#product-grid'))))) schedule();
    }).observe(main, {childList:true, subtree:true});
    document.fonts?.ready.then(schedule);
  }
  window.addEventListener('resize', schedule, {passive:true});
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
